import { gql } from "@apollo/client";

export const AUTORIZAR_MASIVO = gql`
mutation AutorizacionPrecioMasivo($input: [AutorizacionCambioPrecioInput!]!) {
  autorizacionPrecioMasivo(input: $input) {
    success
    error
    valorEsperado
  }
}`;